// extracted by mini-css-extract-plugin
export var adviserImageContainer = "blockQuote-module--adviserImageContainer--w42u1";
export var adviserName = "blockQuote-module--adviserName--EsGIv";
export var blockQuoteContainer = "blockQuote-module--blockQuoteContainer--hfye6";
export var campusQuoteContainer = "blockQuote-module--campusQuoteContainer--Dpf7S";
export var iconNameTitleContainer = "blockQuote-module--iconNameTitleContainer--Vhube";
export var jobTitle = "blockQuote-module--jobTitle--2NYHz";
export var quoteContainer = "blockQuote-module--quoteContainer--qQJAR";
export var quoteImg = "blockQuote-module--quoteImg--P5q+1";